// extracted by mini-css-extract-plugin
export default {"external":"aSsqhM","tagsContainer":"bSsqhM","isSticking":"cSsqhM","cardsContainer":"dSsqhM","disclaimer":"eSsqhM"};